export default __webpack_public_path__ + "static/media/4e3cf6387effaf846c8cdb02e3d04783.svg";